import { render, staticRenderFns } from "./shareGoodList.vue?vue&type=template&id=57c2ba19&scoped=true"
import script from "./shareGoodList.vue?vue&type=script&lang=js"
export * from "./shareGoodList.vue?vue&type=script&lang=js"
import style0 from "./shareGoodList.vue?vue&type=style&index=0&id=57c2ba19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2ba19",
  null
  
)

export default component.exports